import { theme, ThemeConfig } from 'antd';

// --main-color-white: rgb(255,255,255);
// --main-color-black: rgb(0,0,0);
// --main-color-cream: rgb(244,242,233);
// --main-color-yellow: rgb(233,229,203);
// --main-color-teal: rgb(75, 174, 175);
// --main-color-dark-blue: rgb(16,24,35);
// --main-color-grey: rgb(150, 150, 150);

export const defaultTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    fontFamily: `Onest`,
    colorPrimary: 'rgb(0,0,0)',
    colorSuccess: 'rgb(75, 174, 175)',
    colorWarning: 'rgb(75, 174, 175)',
    colorError: 'rgb(244,242,233)',
    colorInfo: 'rgb(244,242,233)',

    colorBgBase: 'rgb(255,255,255)',
    colorTextBase: 'rgb(0,0,0)',

    borderRadius: 24,
    colorSplit: 'rgb(0,0,0)',
    
  },
  components: {
    Modal: {
      titleFontSize: 20
    },
    Image: {
      borderRadius: 24
    },
    Popconfirm: {
      fontSize: 18,
    },
    Button: {
      fontSize: 18,
      colorPrimary: 'rgb(25, 47, 81)',
      colorPrimaryHover: 'rgb(25, 47, 81)',
      colorBorder: 'rgb(0,0,0)',
      borderRadius: 24,
      dangerColor: 'rgb(0,0,0)',
      colorError: '#ff4d4f',
      colorErrorHover: '#ff4d4f',
      colorErrorBorderHover: '#ff4d4f',
      colorErrorText: 'rgb(206,206,206)',
      borderColorDisabled: 'rgb(206,206,206)',
    },
    Checkbox: {
      borderRadiusSM: 2,
      controlInteractiveSize: 24,
        colorBorder: 'rgb(25, 47, 81)',
        colorPrimary: 'rgb(25, 47, 81)',
        colorPrimaryBorder: 'rgb(25, 47, 81)',
        colorPrimaryHover: 'rgb(25, 47, 81)',
        fontSize: 18,
        fontSizeLG: 18,
        colorText: '#000000'
    },
    DatePicker: {
      borderRadius: 6,
      errorActiveShadow: '0 2px 6px rgba(106, 76, 147, 0.3)',
      boxShadow: '0 2px 6px rgba(106, 76, 147, 0.3)',
      colorError: '#ff4d4f',
      colorErrorHover: '#ff4d4f',
      colorErrorBorderHover: '#ff4d4f',
      colorIconHover: 'rgb(0,0,0)',
      activeBorderColor:  'rgb(0,0,0)',
      hoverBorderColor: 'rgb(0,0,0)',
      colorPrimaryHover:  'rgb(0,0,0)',
      fontSize: 18
    },
    Input: {
      borderRadius: 6,
      errorActiveShadow: '0 2px 6px rgba(106, 76, 147, 0.3)',
      boxShadow: '0 2px 6px rgba(106, 76, 147, 0.3)',
      colorError: '#ff4d4f',
      colorErrorHover: '#ff4d4f',
      colorErrorBorderHover: '#ff4d4f',
      colorIconHover: 'rgb(0,0,0)',
      activeBorderColor:  'rgb(0,0,0)',
      hoverBorderColor: 'rgb(0,0,0)',
      colorPrimaryHover:  'rgb(0,0,0)',
      fontSize: 18
    },
    InputNumber: {
      borderRadius: 6,
      errorActiveShadow: '0 2px 6px rgba(106, 76, 147, 0.3)',
      boxShadow: '0 2px 6px rgba(106, 76, 147, 0.3)',
      colorError: '#ff4d4f',
      colorErrorHover: '#ff4d4f',
      colorErrorBorderHover: '#ff4d4f',
      colorIconHover: 'rgb(0,0,0)',
      activeBorderColor:  'rgb(0,0,0)',
      hoverBorderColor: 'rgb(0,0,0)',
      colorPrimaryHover:  'rgb(0,0,0)',
      fontSize: 18
    },
    Select: {
      borderRadius: 6,
      boxShadow: '0 2px 6px rgba(106, 76, 147, 0.3)',
      optionSelectedBg: 'rgb(206,206,206)',
      colorError: '#ff4d4f',
      colorErrorHover: '#ff4d4f',
      colorErrorBorderHover: '#ff4d4f',
      colorIconHover: 'rgb(0,0,0)',
      activeBorderColor:  'rgb(0,0,0)',
      hoverBorderColor: 'rgb(0,0,0)',
      colorPrimaryHover:  'rgb(0,0,0)',
      controlOutline: 'transparent',
      fontSize: 18
    },
    Carousel: {
      arrowSize: 14,
      dotActiveWidth: 24,
      dotHeight: 6,
      dotWidth: 12,
    },
    Divider: {
      colorSplit: '#e8e8e8',
    },
    Breadcrumb: {
      itemColor: 'rgb(255,255,255)',
      lastItemColor: '#FFFFFF50',
      linkColor: 'rgb(255,255,255)',  
      linkHoverColor: 'rgb(255,255,255)'
    }
  },
};

export const increasedContrastTheme: ThemeConfig = {
    ...defaultTheme,
    algorithm: theme.darkAlgorithm,
    token: { 
        ...defaultTheme.token, 
        // colorPrimary: '#722ed1', 
        // colorBgBase: '#001529' 
        colorPrimary: '#000000',
    },
    components: {
        ...defaultTheme.components,
        Button: {
            ...defaultTheme.components!.Button,
            colorPrimary: '#000000',
            colorPrimaryHover: '#000000',
        },
        Breadcrumb: {
            itemColor: '#FFFFFF',
            lastItemColor: '#FFFFFF',
            linkColor: '#FFFFFF',
            linkHoverColor: '#FFFFFF'
        }
    }
}
